import React from "react";
import Dispatcher from "../../dispatcher";
import FractionStore from "../../stores/fraction-store";
import BookStore from "../../stores/book-store";
import NavigatorAction from "../../actions/navigator-action";
import gadgets from "../gadgets/gadgets";
import { toastUtils } from "../../utils/toast-utils";
import MainMenuMixin from "../ui_elements/main-menu-mixin";
import ModalManager from "../layouts/modal-manager";
import CustomIframe from "./custom-iframe";
import PanelContainer from "./panel-container";
import Tour from "../tour/tour";
import LoadingContainer from "../layouts/loading-container";
import setTitle from "../../utils/set-title";
import { areFlashcardPageImagesEnabledForBrand } from "../gadgets/src/flash-cards/utils";
import LibraryHelpers from "../../stores/library-helpers";

var BookContainer = require("./book-container");
var SidebarContainer = require("./vertical-toolbar-container");
var ScrubberContainer = require("./scrubber-container");
var Tooltip = require("../ui_elements/tooltip").Tooltip;
var TooltipMixin = require("../ui_elements/tooltip").TooltipMixin;
var MainMenu = require("../ui_elements/main-menu").MainMenu;
var MenuMixin = require("../ui_elements/menu").MenuMixin;
var OnBoardingHelper = require("../onboarding/onboarding-container")
  .OnBoardingHelper;
var Isvg = require("../../../vendor/react-inlinesvg");
var JigsawPlaceholder = require("./jigsaw-placeholder");
var AccessCodeModal = require("../gadgets/src/online-resources/access-code-modal");
var NewReaderOnboarding = require("./onboarding/new-reader-onboarding");

var isMounted;

/*
  Renders the Reader
    props: book
    state:
*/
class Container extends React.Component {
  constructor(props) {
    super(props);

    this.timeoutRebuildCount = 0;
    this.savedChromeStates = {};

    this.panelContainerRef = React.createRef();
    this.tourRef = React.createRef();

    this.state = {
      ancillaries: [],
      scrubber_expanded: "scrubber-expanded",
      panels: [],
      fastHighlighting: Fraction.Helpers.isLabEnabled("instant-highlights")
    };

    // TooltipMixin bindings
    this.showTooltip = TooltipMixin.showTooltip.bind(this);
    this.removeTooltip = TooltipMixin.removeTooltip.bind(this);
    this._addTooltipEvent = TooltipMixin._addTooltipEvent.bind(this);
    this._removeTooltipEvent = TooltipMixin._removeTooltipEvent.bind(this);

    // MenuMixin bindings
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // MainMenuMixin bindings
    this._toggleMainMenu = MainMenuMixin._toggleMainMenu.bind(this);
    this._menuOpen = MainMenuMixin._menuOpen.bind(this);
    this._menuClose = MainMenuMixin._menuClose.bind(this);
    this._menuRefocus = MainMenuMixin._menuRefocus.bind(this);

    // Bind all component methods that use `this`
    this._createPageViewer = this._createPageViewer.bind(this);
    this._updateImageButtons = this._updateImageButtons.bind(this);
    this._setDocumentTitle = this._setDocumentTitle.bind(this);
    this._fractionStoreChange = this._fractionStoreChange.bind(this);
    this._handleNoCopy = this._handleNoCopy.bind(this);
    this._panelChange = this._panelChange.bind(this);
    this._changeChrome = this._changeChrome.bind(this);
    this._startTimeoutRebuild = this._startTimeoutRebuild.bind(this);
    this._clearTimeoutRebuild = this._clearTimeoutRebuild.bind(this);
    this._pageBreaksLoaded = this._pageBreaksLoaded.bind(this);
    this._embeddedReceiver = this._embeddedReceiver.bind(this);
    this._bookOpened = this._bookOpened.bind(this);
    this._pageReady = this._pageReady.bind(this);
    this._autoTurnOnBeforeFiltersEnhancedFormatting = this._autoTurnOnBeforeFiltersEnhancedFormatting.bind(this);
    this._bookClick = this._bookClick.bind(this);
    this._pageScroll = this._pageScroll.bind(this);
    this._updatePageNumber = this._updatePageNumber.bind(this);
    this._updateDimensions = this._updateDimensions.bind(this);
    this._homeButtonEvent = this._homeButtonEvent.bind(this);
    this._threeBarVerticalEvent = this._threeBarVerticalEvent.bind(this);
    this._customButtonEvent = this._customButtonEvent.bind(this);
    this._openSearchWithTerm = this._openSearchWithTerm.bind(this);
    this._bookmarkButtonEvent = this._bookmarkButtonEvent.bind(this);
    this._fastHighlightingEvent = this._fastHighlightingEvent.bind(this);
    this._singlePageViewEvent = this._singlePageViewEvent.bind(this);
    this._twoPageViewEvent = this._twoPageViewEvent.bind(this);
    this._continuousScrollEvent = this._continuousScrollEvent.bind(this);
    this._toggleScrubberContainer = this._toggleScrubberContainer.bind(this);
    this._showScrubberContainer = this._showScrubberContainer.bind(this);
    this._resetScrubber = this._resetScrubber.bind(this);
    this._hideScrubberContainer = this._hideScrubberContainer.bind(this);
    this._hideMobileMenus = this._hideMobileMenus.bind(this);
    this._showMobileMenus = this._showMobileMenus.bind(this);
    this._toggleMobileMenu = this._toggleMobileMenu.bind(this);
    this._cancelShowingScrubber = this._cancelShowingScrubber.bind(this);
    this._addTooltip = this._addTooltip.bind(this);
    this._removeTooltip = this._removeTooltip.bind(this);
    this._updatePowerByClass = this._updatePowerByClass.bind(this);
    this._redraw = this._redraw.bind(this);
    this._delayRedraw = this._delayRedraw.bind(this);
    this._getReaderButtons = this._getReaderButtons.bind(this);
    this._getBookTemplate = this._getBookTemplate.bind(this);
    this._saveChromeState = this._saveChromeState.bind(this);
    this._loadChromeState = this._loadChromeState.bind(this);
    this._skipAhead = this._skipAhead.bind(this);
    this._hideEresourceModal = this._hideEresourceModal.bind(this);
    this._revealAccessCode = this._revealAccessCode.bind(this);
    this._renderRevealButton = this._renderRevealButton.bind(this);
    this._showEresourceModal = this._showEresourceModal.bind(this);
    this.renderMinimizedChrome = this.renderMinimizedChrome.bind(this);
    this._buildChrome = this._buildChrome.bind(this);
  }

  componentDidMount() {
    // Merged from componentWillMount
    gadgets.forEach(gadget => {
      gadget.active = false;
    });
    toastUtils.dismiss(`expired-book-toast`);
    toastUtils.dismiss(`expiring-soon-book-toast`);
    window.Dispatch = Dispatcher;
    this._updateDimensions();
    Fraction.Helpers.setDataObject("Reader.currentBook", {});
    this.currentBookData = Fraction.Helpers.getDataObject("Reader.currentBook");
    this._clearTimeoutRebuild();
    Dispatcher.emit(Dispatcher.NOTES_UP); // plot twist, notes might not be up, but this is how we can reset it in case they are
    document.title = setTitle(Fraction.Brand);
    // End of merged componentWillMount

    if (this.props.activeChrome) {
      const { id, props } = this.props.activeChrome;
      this._changeChrome(id, props);
      Dispatcher.emit(Dispatcher.CHANGE_CHROME, id);
    }
    this.mounted = true;
    var container = this;
    $("#home-button").removeAttr("aria-pressed");
    const book = BookStore.get(this.props.isbn);
    this._createPageViewer();

    Fraction.Helpers.getUser(
      function () {
        this.forceUpdate();
      }.bind(this)
    );

    // bind window events
    window.addEventListener("resize", this._updateDimensions);
    window.addEventListener("message", this._embeddedReceiver, false);

    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 13);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_SCROLL, this._pageScroll);
    Dispatcher.bind(Dispatcher.BOOK_CLICK, this._bookClick);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.bind(
      Dispatcher.BOOK_SELECTION_WITH_POSITION,
      this._hideMobileMenus
    );
    Dispatcher.bind(Dispatcher.BOOK_HIGHLIGHT_CLICK, this._hideMobileMenus);
    Dispatcher.bind(Dispatcher.BOOK_NOTEICON_CLICK, this._hideMobileMenus);
    Dispatcher.bind(Dispatcher.BOOK_PAGEBREAKS_LOADED, this._pageBreaksLoaded);
    Dispatcher.bind(Dispatcher.CHANGE_CHROME, this._changeChrome);
    Dispatcher.bind(Dispatcher.PANEL_CHANGE, this._panelChange);
    Dispatcher.bind(Dispatcher.BOOK_OPENED, this._bookOpened);
    Dispatcher.bind(Dispatcher.BOOK_CHANGE, this._setDocumentTitle);
    Dispatcher.bind(
      Dispatcher.SET_FAST_HIGHLIGHTER,
      this._fastHighlightingEvent
    );

    Dispatcher.bindOnce(Dispatcher.BOOK_PAGE_READY, function (e, data) {
      if (container.props.searchOnOpen) {
        container._openSearchWithTerm(container.props.searchOnOpen);
      }
    });
    Dispatcher.bind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChange
    );
    Dispatcher.bind(Dispatcher.LOCALE_CHANGE, this._fractionStoreChange);
    Dispatcher.bind(Dispatcher.BOOK_NO_COPY, this._handleNoCopy);

    Fraction.Helpers.registerCFIChange(cfi => {
      if (this.props.url) {
        book.goTo({ url: this.props.url });
      } else {
        book.goTo({ cfi: cfi });
      }
    });

    Fraction.Helpers.modalRedraw = this._redraw;

    this.readOfflineTimeout = Fraction.Helpers.readOffline(
      this.props.isbn,
      false,
      null
    );

    if (
      Fraction.User &&
      !Fraction.User.labs["review-mode"] &&
      Fraction.Brand.Labs.enabled
    ) {
      // Show labs message.
      var steps = [
        {
          message: i18n.t("labs.discover-message"),
          boldMessage: i18n.t("labs.discover-title"),
          nextText: i18n.t("base.tour"),
          targetSelector: "#labs-button",
          menuDirection: "right",
          timeout: 500,
          theme: "dark",
          teardown: () => OnBoardingHelper._labsOnboarding($("#labs-button"))
        }
      ];

      setTimeout(() => {
        Dispatcher.emit(Dispatcher.NEW_TOUR, steps);
      }, 500);
      Fraction.Helpers.Labs.enableLab("review-mode");
    }
    book.updateZoomScale();
    isMounted = true;
    this._updateImageButtons();
  }

  componentDidUpdate(prevProps, prevState) {
    Fraction.currentISBN = this.props.isbn;
    const book = BookStore.get(this.props.isbn);
    if (book.bookIsRebuilding) {
      this._startTimeoutRebuild(this.props.isbn, this._redraw);
      Fraction.Helpers.addLoader(
        "#reader-tools",
        "background:#FFF;",
        i18n.t("reader.book-rebuilding")
      );
    }
    if (
      prevState.fastHighlighting !== this.state.fastHighlighting ||
      prevState.context !== this.state.context
    ) {
      const toggle = this.state.fastHighlighting ? "on" : "off";
      const toast =
        this.state.context === "instant-highlights"
          ? i18n.t(`instant-highlights.turned-${toggle}`)
          : i18n.t(`reader.buttons.fast-highlighting-${toggle}`);

      toastUtils.notify(toast, {
        type: this.state.fastHighlighting ? "success" : "info"
      });
      this._getReaderButtons(true);
      this._redraw();
      Fraction.Reporter.gaEvent(
        "reader/options/fast-highlighting-" +
          (this.state.fastHighlighting ? "on" : "off")
      );
    }

    // Check to see if a panel is open on mobile. If it is, move the book off screen
    // to prevent background scrolling on iOS.
    if (
      Fraction.Helpers.isSmallScreen() &&
      $("#panel-container .panel:visible:not(.review-container)").length > 0
    ) {
      $("#book-container").hide();
    } else {
      $("#book-container").show();
    }

    this._updateImageButtons();
    LibraryHelpers.supportedBrowserToast();
  }

  componentWillUnmount() {
    this.mounted = false;
    Fraction.lastISBN = Fraction.currentISBN;
    Fraction.currentISBN = undefined;
    this._removeMenu();
    clearTimeout(this.readOfflineTimeout);
    clearTimeout(this.onboardingTimeout);
    window.removeEventListener("resize", this._updateDimensions);
    window.removeEventListener("message", this._embeddedReceiver);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_SCROLL, this._pageScroll);
    Dispatcher.unbind(Dispatcher.BOOK_CLICK, this._bookClick);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.unbind(
      Dispatcher.BOOK_SELECTION_WITH_POSITION,
      this._hideMobileMenus
    );
    Dispatcher.unbind(Dispatcher.BOOK_HIGHLIGHT_CLICK, this._hideMobileMenus);
    Dispatcher.unbind(Dispatcher.BOOK_NOTEICON_CLICK, this._hideMobileMenus);
    Dispatcher.unbind(
      Dispatcher.BOOK_PAGEBREAKS_LOADED,
      this._pageBreaksLoaded
    );
    Dispatcher.unbind(Dispatcher.CHANGE_CHROME, this._changeChrome);
    Dispatcher.unbind(Dispatcher.PANEL_CHANGE, this._panelChange);
    Dispatcher.unbind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChange
    );
    Dispatcher.unbind(Dispatcher.LOCALE_CHANGE, this._fractionStoreChange);
    Dispatcher.unbind(Dispatcher.BOOK_NO_COPY, this._handleNoCopy);
    Dispatcher.unbind(Dispatcher.BOOK_OPENED, this._bookOpened);
    Dispatcher.unbind(Dispatcher.BOOK_CHANGE, this._setDocumentTitle);
    Dispatcher.unbind(
      Dispatcher.SET_FAST_HIGHLIGHTER,
      this._fastHighlightingEvent
    );
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 13);
    Fraction.Helpers.unregisterCFIChange();
    this._clearTimeoutRebuild();
    this._saveChromeState("assignment-creator-chrome", false);
    this._saveChromeState("assignment-reader-chrome", false);
    NavigatorAction.reset();
    const book = BookStore.get(this.props.isbn);
    book._destroy();
    isMounted = false;
    toastUtils.dismiss("eresources-access-code-toast");
  }

  _createPageViewer() {
    BookStore._createPageViewer(this.props.isbn, {
      initialCFI: this.props.initialCFI,
      url: this.props.url,
      initialPage: this.props.initialPage,
      dpsOn:
        Fraction.Brand.DoublePageSpread.enabled &&
        !!Fraction.Helpers.getDataObject("User.Persist.DPS")[this.props.isbn],
      imageButtons: {
        featureAvailable: areFlashcardPageImagesEnabledForBrand(),
        label: i18n.t("flashcards.images.create-card"),
        // Flashcard icon
        content:
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 26 23"><g><path fill="currentColor" d="M5 7h12v1H5z"/><path fill="currentColor" d="M5 10h12v1H5z"/><path fill="currentColor" d="M24 5h-2V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h2v3c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM4 16H2V2h18v14H4zm20 5H6v-3h14c1.1 0 2-.9 2-2V7h2v14z"/></g></svg>'
      }
    });
  }

  _updateImageButtons() {
    const book = BookStore.get(this.props.isbn);
    if (areFlashcardPageImagesEnabledForBrand()) {
      if (this.state.chrome) {
        book.viewer.Viewport.disableImageButtons();
      } else {
        book.viewer.Viewport.enableImageButtons();
      }
    }
  }

  _setDocumentTitle() {
    const book = BookStore.get(this.props.isbn);
    if (book.title) {
      document.title += `: ${book.title}`;
      Dispatcher.unbind(Dispatcher.BOOK_CHANGE, this._setDocumentTitle);
    }
  }

  _fractionStoreChange() {
    this.forceUpdate();
  }

  _handleNoCopy() {
    toastUtils.notify(i18n.t("reader.no-copy"));
  }

  _panelChange(gadget) {
    this._getReaderButtons(true);
    if (gadget) {
      this.setState({ activePanel: gadget.active });
    } else {
      this.forceUpdate();
    }
  }

  _changeChrome(id, chromeProps, callback) {
    this._resetScrubber();
    const chrome = gadgets.find(gadget => gadget.metadata().id === id);
    if (chrome) {
      Dispatcher.emit(Dispatcher.HIDE_ALL_PANELS);
    } else {
      Dispatcher.emit(Dispatcher.LOAD_SAVED_PANELS);
    }
    this.setState(
      {
        chrome: chrome,
        chromeProps: chromeProps
      },
      function () {
        // Required to get the navigation updates to trigger without page ready.
        Dispatcher.emit(Dispatcher.BOOK_CHANGE);
        const book = BookStore.get(this.props.isbn);
        book.updateZoomScale();
        if (typeof callback === "function") {
          callback();
        }
      }
    );
  }

  // This exists in the reader now (instead of book)
  // because the reader is the only one that cares about rebuilding books
  _startTimeoutRebuild(isbn, redraw) {
    if (this.timeoutRebuildCount >= 2) {
      Fraction.Router.setRoute("/");
      setTimeout(function () {
        Fraction.Helpers.toast(i18n.t("reader.book-long-rebuild"));
      }, 1000);
      return;
    }
    if (!this.timeoutRebuild) {
      this.timeoutRebuild = setTimeout(() => {
        if (this.mounted) {
          $("#book-container")
            .find("iframe")
            .each(function () {
              this.src = "";
            });
          $("#book-container").html("");
          var tmpRebuildCount = this.timeoutRebuildCount; // store because it gets reset in init
          this._createPageViewer();
          this.timeoutRebuildCount = tmpRebuildCount;
          this.timeoutRebuild = false;
          this.timeoutRebuildCount++;
        }
      }, 4000);
    }
  }

  _clearTimeoutRebuild() {
    if (this.timeoutRebuild) {
      clearTimeout(this.timeoutRebuild);
      this.timeoutRebuild = false;
    }
    this.timeoutRebuildCount = 0;
  }

  _pageBreaksLoaded() {
    this._getReaderButtons(true);
  }

  _embeddedReceiver(e) {
    gadgets.map(gadget => {
      if (gadget.metadata().type === "panel") {
        if (e.data === `fraction:event:show${gadget.metadata().id}`) {
          Dispatcher.emit(Dispatcher.SHOW_PANEL, gadget.metadata().id);
          return;
        } else if (e.data === `fraction:event:hide{gadget.metadata().id}`) {
          Dispatcher.emit(Dispatcher.HIDE_PANEL, gadget.metadata().id);
          return;
        }
      }
    });
    const book = BookStore.get(this.props.isbn);
    switch (e.data) {
      case "fraction:event:nextpage":
        book.viewer.Book.goToNextPage(function () {});
        return;
      case "fraction:event:previouspage":
        book.viewer.Book.goToPreviousPage(function () {});
        return;
    }
    if (e.data.indexOf && e.data.indexOf("fraction:event:gotopage:") !== -1) {
      var page = e.data.split(":").reverse()[0];
      book.goTo({ page: page });
      return;
    }
  }

  _bookOpened() {
    this._getReaderButtons(true);
    Dispatcher.emit(Dispatcher.LOAD_SAVED_PANELS);
    Jigsaw.getAncillariesSummary(
      function (response) {
        if (response.isSuccess() && isMounted) {
          this.setState(
            { ancillaries: response.data.ancillaries },
            this._showEresourceModal
          );
        }
      }.bind(this)
    );
  }

  _pageReady(isbn, e, data) {
    const book = BookStore.get(this.props.isbn);
    if (book.viewerIsReady) {
      if (data.code === 404) {
        return;
      }
      const route = `${this.props.route}cfi${data.cfi}`;
      if (window.location.hash !== "#" + route) {
        Fraction.Router.setRoute(route, true);
      }
      setTimeout(function () {
        Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
      }, 350);
      this.lastCFI = data.cfi || this.lastCFI;
      this._autoTurnOnBeforeFiltersEnhancedFormatting();
    }
  }

  _autoTurnOnBeforeFiltersEnhancedFormatting() {
    if (Fraction.Brand.ContentControls.applyBeforeCSS) {
      const book = BookStore.get(this.props.isbn);
      if (book.vbkType && book.vbkType === "epub") {
        book.viewer.Book.addEnhancedFormattingCSS();
      }
    }
  }

  _bookClick(isbn, e) {
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    if (!menuData.menuId || menuData.menuId !== "create-highlight-menu") {
      this._toggleMobileMenu();
      this._toggleScrubberContainer();
    }
  }

  _pageScroll(isbn, e, data) {
    Fraction.Helpers.delayTimeout(
      function () {
        this.checkScrollDirection = true;
      }.bind(this),
      250,
      "checkScrollDirectionTimeout"
    );

    // Update the url with the current cfi, without creating a new browser history entry
    Fraction.Helpers.delayTimeout(
      function () {
        if (this.mounted) {
          var hash = window.location.hash.split("!")[0] + "!" + data.cfi;

          // We need to remove assertions (in square brackets) in order to use the same
          // formatting as we get from page:ready (which doesn't include assertions by default).
          // Otherwise, the router will think that the hash has changed and will mess up
          // the browser history.
          hash = Fraction.Helpers.stripAssertions(hash);

          window.history.replaceState({}, "", hash);
        }
      }.bind(this),
      250,
      "updateUrlOnScrollTimeout"
    );

    if (this.checkScrollDirection) {
      var dir = 0;
      this.currentBookData.cfi = data.cfi;
      if (this.lastPageScroll) {
        dir = Jigsaw.CFIUtils.compareCFIs(data.cfi, this.lastPageScroll);
      }
      this.lastPageScroll = data.cfi;
      if (this.lastPageDir === dir) {
        this.checkScrollDirection = false;
        if (dir === 1) {
          setTimeout(
            function () {
              this._hideMobileMenus();
            }.bind(this),
            50
          );
          //setTimeout(function(){ this._hideScrubberContainer(1); }.bind(this), 200);
        } else if (dir === -1) {
          setTimeout(
            function () {
              this._hideMobileMenus();
            }.bind(this),
            50
          );
          //setTimeout(function(){ this._showMobileMenus(); }.bind(this), 200);
        }
      }
      this.lastPageDir = dir;
    }

    this.lastCFI = data.cfi || this.lastCFI;
  }

  _updatePageNumber(page) {
    this.currentBookData.page = page;
    this.forceUpdate();
  }

  // Update window dimensions to set the state based on resize events
  // Good for determining how many buttons to fit on a screen
  _updateDimensions() {
    this._getReaderButtons(true);
    this.setState({ width: $(window).width(), height: $(window).height() });
  }

  // Fire this when the home button is clicked
  _homeButtonEvent() {
    Fraction.Router.setRoute("/");
  }

  // Fire this when the three bar menu is clicked
  _threeBarVerticalEvent(e) {
    this._removeMenu();
    MainMenuMixin._toggleMainMenu(e, this._updatePowerByClass);
    this._getReaderButtons(true);
  }

  // Fire when custom button is clicked
  _customButtonEvent() {
    var custom = Fraction.Brand.Sidebar.Buttons.custom;
    if (custom && custom.enabled) {
      if (
        custom.lti &&
        custom.lti.enabled &&
        Fraction.User.contextTokens &&
        !Fraction.User.contextTokens[this.props.isbn]
      ) {
        this._toggleMenu(
          { currentTarget: $(".custom-button").get(0) },
          { menuId: "gps-lti-unavailable" }
        );
      } else {
        if (custom.modal) {
          var modalPadding =
            Fraction.Brand.Sidebar.Buttons.custom["modal-padding"];
          // show modal
          Fraction.Helpers.showModal(
            {
              title: custom.title,
              content: <CustomIframe custom={custom} isbn={this.props.isbn} />,
              fullscreen: true,
              padding: modalPadding
            },
            $(".custom-button"),
            $("#reader-tools")
          );
        } else {
          // open url in new window
          Fraction.Helpers.Locations.safeRedirect(custom.url, "_blank");
        }
      }
    }
  }

  // sets the search in the search panel, then shows it if necessary
  _openSearchWithTerm(term) {
    Dispatcher.emit(Dispatcher.SHOW_PANEL, "search");
    setTimeout(
      function () {
        Fraction.Helpers.fireEvent("update-search-term", { value: term });
        this.setState({ initialSearchTerm: term });
      }.bind(this),
      0
    );
  }

  // Bookmark button event
  _bookmarkButtonEvent() {
    this._showMenu(false, {
      menuId: "bookmark-menu-mobile",
      refocusDOM: $("#bookmarks-button"),
      calledButtonDOM: $("#bookmarks-button").get(0),
      currentTarget: $("#bookmarks-button").get(0)
    });
  }

  // Fash Highlight button event
  _fastHighlightingEvent(fastHighlighting, context) {
    this.setState(prevState => {
      if (prevState.fastHighlighting !== fastHighlighting) {
        return { fastHighlighting, context };
      }
    });
  }

  // Single Page View button event
  _singlePageViewEvent() {
    Fraction.Reporter.gaEvent("reader/display/single-page-view");
  }

  // Two Page View button event
  _twoPageViewEvent() {
    Fraction.Reporter.gaEvent("reader/display/two-page-view");
  }

  // Continuous Scroll button event
  _continuousScrollEvent() {
    Fraction.Reporter.gaEvent("reader/display/continuous-scroll");
  }

  // Toggle the visibility of the scrubber
  _toggleScrubberContainer() {
    if (this.mobileMenuHidden && $("#scrubber-container").offset()) {
      if ($("#scrubber-container").offset().top > $(window).height() - 12) {
        this._showScrubberContainer();
      } else {
        this._hideScrubberContainer(1);
      }
    }
  }

  // Show the expanded scrubber container
  _showScrubberContainer(e) {
    Dispatcher.emit(Dispatcher.SCRUBBER_OPEN);
    if (this.state.chrome) {
      return;
    }
    if (
      this.mobileMenuHidden &&
      $("#scrubber-container").offset().top > $(window).height() - 12 &&
      !this.showingScrubberAnimation
    ) {
      // ignore this if you're not over the reading view
      if (e && e.pageX) {
        var readerX = $("#book-container").offset().left;
        if (
          (e.pageX < readerX ||
            e.pageX > readerX + $("#book-container").width()) &&
          e.pageY < $(e.currentTarget).children().first().offset().top + 20
        ) {
          return;
        }
      }
      this.showingScrubberAnimation = true;
      clearTimeout(this.hideScrubberTimeout);
      this.hideScrubberTimeout = undefined;
      clearTimeout(this.showScrubberTimeout);
      this.showScrubberTimeout = undefined;
      $("#scrubber-container").stop();
      $("#book-wrapper").stop();
      $("#scrubber-container #scrubber").stop();
      $("#scrubber-container #tts-toolbar").stop();
      this.showScrubberTimeout = setTimeout(() => {
        var hidetime = 250;
        this.setState({ scrubber_expanded: "scrubber-expanded" });
        $("#book-wrapper").animate({ bottom: 50 }, hidetime);
        $("#scrubber-container").animate({ bottom: 0 }, hidetime);
        $("#scrubber-container #scrubber #handle").show();
        $("#scrubber-container #scrubber").addClass("expanded");
        $("#scrubber-container #scrubber").animate(
          {
            left: 24,
            right: $(".scrubber-buttons").width() + 25,
            top: 50
          },
          hidetime
        );
        $("#scrubber-container #tts-toolbar").animate(
          {
            top: 0
          },
          hidetime
        );
        setTimeout(() => {
          this.showingScrubberAnimation = false;
        }, hidetime);
      }, 10);
    }
  }

  _resetScrubber() {
    clearTimeout(this.hideScrubberTimeout);
    this.hideScrubberTimeout = undefined;
    clearTimeout(this.showScrubberTimeout);
    this.showScrubberTimeout = undefined;
    this.mobileMenuHidden = false;
  }

  // Hide the expanded scrubber container
  _hideScrubberContainer(timeout) {
    Dispatcher.emit(Dispatcher.SCRUBBER_CLOSE);
    if (this.state.chrome) {
      return;
    }
    if (timeout % 1 !== 0) {
      timeout = 0;
    }
    if (this.mobileMenuHidden) {
      clearTimeout(this.showScrubberTimeout);
      this.showScrubberTimeout = undefined;
      if (!this.hideScrubberTimeout) {
        this.hideScrubberTimeout = setTimeout(() => {
          var hidetime = 250;
          $("#scrubber-container").stop();
          $("#book-wrapper").stop();
          $("#scrubber-container #scrubber").stop();
          $("#scrubber-container #tts-toolbar").stop();
          $(".vertical-scroll-navigation").hide();
          $("#scrubber").css("background", "");
          $(".book-slide.vertical").animate(
            { height: $(".book-slide").height() + 77 },
            hidetime
          );
          $("#book-wrapper").animate({ bottom: 6 }, hidetime);
          $("#scrubber-container").animate(
            {
              bottom: -($("#scrubber-container").height() - 6)
            },
            hidetime,
            () => {
              this.setState({ scrubber_expanded: "" });
            }
          );
          $("#scrubber-container #scrubber").animate(
            {
              left: 0,
              right: 0,
              top: 0
            },
            hidetime,
            function () {
              $("#scrubber-container #scrubber #handle").hide();
              $("#scrubber-container #scrubber").removeClass("expanded");
            }
          );
          $("#scrubber-container #tts-toolbar").animate(
            {
              top: 0
            },
            hidetime,
            () => {}
          );
        }, timeout);
      }
    }
  }

  // Hide the modal menus when scrolling or tapping on content
  _hideMobileMenus() {
    if (
      this.mounted &&
      !this.mobileMenuHidden &&
      $("#mobile-toolbar").length > 0
    ) {
      this.mobileMenuHidden = true;
      var hidetime = 200;
      $("#mobile-scrubber-container #scrubber").stop();
      $("#mobile-scrubber-container #tts-toolbar").stop();
      if (
        $("#mobile-toolbar").offset().top <= 0 &&
        Fraction.Helpers.isSmallScreen()
      ) {
        $("#tooltip-with-arrow").hide();
      }
      $("#mobile-scrubber-container").stop();
      $("#mobile-toolbar").stop();
      $("#book-wrapper").stop();
      setTimeout(function () {
        $("#mobile-scrubber-container").animate(
          {
            bottom: -$("#mobile-scrubber-container").height() - 7
          },
          hidetime,
          function () {}
        );
        $("#mobile-toolbar").animate(
          {
            top: -$("#mobile-toolbar").height()
          },
          hidetime,
          function () {
            $("#mobile-scrubber-container #scrubber").removeClass("expanded");
          }
        );
        $("#mobile-scrubber-container #scrubber").animate(
          {
            left: 0,
            right: 0,
            top: -6
          },
          hidetime,
          function () {}
        );
        $("#mobile-scrubber-container #tts-toolbar").animate(
          {
            top: -6
          },
          hidetime,
          function () {}
        );
        if ($("#mobile-scrubber-container").is(":visible")) {
          $("#book-wrapper").animate(
            {
              bottom: 0
            },
            hidetime,
            function () {}
          );
        }
      }, 10);
    }
  }

  // Show the modal menus when tapping on content
  _showMobileMenus() {
    if (this.mobileMenuHidden) {
      this.mobileMenuHidden = false;
      var hidetime = 200;
      $("#mobile-scrubber-container #scrubber").stop();
      $("#mobile-scrubber-container #tts-toolbar").stop();
      $("#mobile-scrubber-container").stop();
      $("#mobile-toolbar").stop();
      $("#mobile-scrubber-container #scrubber").addClass("expanded");
      if ($("#mobile-toolbar").offset().top < 0) {
        // scrubber-expanded states are only in effect for desktop
        $("#tooltip-with-arrow").show();
      }
      $("#mobile-scrubber-container #scrubber").animate(
        {
          left: 14,
          right: 14,
          top: 51
        },
        hidetime,
        function () {}
      );
      $("#mobile-scrubber-container #tts-toolbar").animate(
        {
          top: 0
        },
        hidetime,
        function () {}
      );
      $("#mobile-scrubber-container").animate(
        {
          bottom: 0
        },
        hidetime,
        function () {}
      );
      $("#mobile-toolbar").animate(
        {
          top: 0
        },
        hidetime,
        function () {}
      );
    }
  }

  // Toggle the visibility of the mobile menu
  _toggleMobileMenu() {
    if ($("#mobile-toolbar").offset()) {
      if ($("#mobile-toolbar").offset().top < 0) {
        this._showMobileMenus();
      } else {
        this._hideMobileMenus();
      }
    }
  }

  _cancelShowingScrubber(timeout) {
    clearTimeout(this.hideScrubberTimeout);
    this.hideScrubberTimeout = undefined;
    clearTimeout(this.showScrubberTimeout);
    this.showScrubberTimeout = undefined;
    $("#mobile-scrubber-container").stop();
    $("#mobile-toolbar").stop();
    $("#scrubber-container").stop();
    $("#scrubber-container #scrubber").stop();
    $("#scrubber-container #tts-toolbar").stop();
    this.showingScrubberAnimation = false;
    this._hideScrubberContainer(0);
    this._hideMobileMenus();
  }

  // Add the tooltip
  _addTooltip(e) {
    this.showTooltip(
      $(e.currentTarget),
      $(e.currentTarget).data("tooltip"),
      $(e.currentTarget).data("tooltip-location")
    );
  }

  // Remove the tooltip
  _removeTooltip() {
    this.removeTooltip();
  }

  _updatePowerByClass(powerByPositionSt) {
    this.setState({
      powerByPositionSt: powerByPositionSt
    });
  }

  // redraw this container!
  _redraw(callback) {
    setTimeout(() => this.forceUpdate(callback), 0);
  }

  _delayRedraw() {
    Fraction.Helpers.runAfterRender(
      function () {
        this._redraw();
      }.bind(this)
    );
  }

  _getReaderButtons(forceRefresh) {
    const book = BookStore.get(this.props.isbn);
    if (
      forceRefresh === true ||
      !this.buttons ||
      !this.mobile_scrubber_buttons
    ) {
      var buttons = [];
      var mobile_scrubber_buttons = [];

      // top buttons
      if (Fraction.Brand.Library.visible) {
        buttons.push({
          id: "home-button",
          title: i18n.t("main-menu.library").capitalize(),
          top: true,
          rank: 100,
          clickEvent: this._homeButtonEvent,
          icon: "/img/home.svg"
        });
      }

      if (
        Fraction.Brand.Sidebar.Buttons.custom &&
        Fraction.Brand.Sidebar.Buttons.custom.enabled
      ) {
        buttons.push({
          id: "custom-button",
          title: Fraction.Brand.Sidebar.Buttons.custom.title,
          top: true,
          rank: 80,
          clickEvent: this._customButtonEvent,
          icon: `/img/${Fraction.Brand.Sidebar.Buttons.custom.icon}.svg`
        });
      }

      // bottom buttons
      gadgets.map(gadget => {
        const metadata = gadget.metadata();
        if (metadata.sidebar && metadata.enabled(this.props.isbn)) {
          const notificationCount = metadata.notificationCount
            ? metadata.notificationCount()
            : 0;
          buttons.push({
            id: `${metadata.id}-button`,
            title: metadata.sidebar.toolTip
              ? metadata.sidebar.toolTip(this.props.isbn)
              : metadata.name,
            top: false,
            rank: 100,
            clickEvent: () => {
              metadata.sidebar.action(this.props.isbn);
            },
            active: gadget.active,
            icon: metadata.sidebar.icon,
            light: metadata.sidebar.light
              ? () => metadata.sidebar.light(this.props.isbn)
              : undefined,
            activeMethod: metadata.sidebar.activeMethod || "highlight",
            notificationCount: notificationCount
          });
          if (!metadata.hideInMobile) {
            mobile_scrubber_buttons.push({
              id: `${metadata.id}-button`,
              title: metadata.sidebar.toolTip
                ? metadata.sidebar.toolTip(this.props.isbn)
                : metadata.name,
              top: false,
              rank: 100,
              clickEvent: () => {
                metadata.sidebar.action(this.props.isbn);
              },
              active: gadget.active,
              light: metadata.sidebar.light
                ? () => metadata.sidebar.light(this.props.isbn)
                : undefined,
              notificationCount: notificationCount
            });
          }
        }
      });

      // sort by rank
      buttons = buttons.sort(function (a, b) {
        return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : 0;
      });
      this.buttons = buttons;
      this.mobile_scrubber_buttons = mobile_scrubber_buttons;
    }
  }

  _getBookTemplate(BookJSX, Objects) {
    const book = BookStore.get(this.props.isbn);
    this._getReaderButtons();

    Fraction.Helpers.setReaderTop();

    var bookWrapperDimensions = {
      top: 0,
      left: 0,
      width: $(window).outerWidth(true),
      height: $(window).outerHeight(true)
    };
    if ($("#book-wrapper").length > 0) {
      bookWrapperDimensions = {
        top: $("#book-wrapper").offset().top,
        left: $("#book-wrapper").offset().left,
        width: $("#book-wrapper").outerWidth(true),
        height: $("#book-wrapper").outerHeight(true)
      };
    }
    bookWrapperDimensions.right =
      $(window).width() -
      (bookWrapperDimensions.left + bookWrapperDimensions.width);
    bookWrapperDimensions.bottom =
      $(window).height() -
      (bookWrapperDimensions.top + bookWrapperDimensions.height);

    return (
      <div id="reader">
        {Objects}
        {book.viewerIsReady && <NewReaderOnboarding />}
        {Fraction.Brand.Sidebar.visible && (
          <SidebarContainer
            home={true}
            desktopButtons={this.buttons}
            isbn={this.props.isbn}
            scrubber_expanded={this.state.scrubber_expanded}
            window_height={this.state.height}
            powerByPositionSt={this.state.powerByPositionSt}
            updatePowerByClass={this._updatePowerByClass}
          />
        )}
        <div
          aria-hidden={FractionStore.get()["modal-open"]}
          id="reader-content"
          className={!Fraction.Brand.Sidebar.visible && "no-sidebar"}
        >
          <div id="reader-tools">
            {!book.bookIsRebuilding &&
              !book.bookAccessDenied &&
              !book.bookDoesNotExist && (
                <PanelContainer
                  ref={this.panelContainerRef}
                  isbn={this.props.isbn}
                  scrubber_expanded={this.state.scrubber_expanded}
                  hideMobileMenus={this._hideMobileMenus}
                  showMobileMenus={this._showMobileMenus}
                />
              )}
            {BookJSX}

            {!book.bookIsRebuilding &&
              !book.bookAccessDenied &&
              !book.bookDoesNotExist && (
                <ScrubberContainer
                  toggleMobileMenuEvent={this._toggleMobileMenu}
                  hideMobileMenuEvent={this._hideMobileMenus}
                  isbn={this.props.isbn}
                  expanded={this.state.scrubber_expanded}
                  mobileButtons={this.mobile_scrubber_buttons}
                  fastHighlightClick={this._fastHighlightingEvent}
                  fastHighlighting={this.state.fastHighlighting}
                  showScrubberEvent={this._showScrubberContainer}
                  hideScrubberEvent={this._hideScrubberContainer}
                  toggleScrubberEvent={this._toggleScrubberContainer}
                  bookWrapperDimensions={bookWrapperDimensions}
                  updatePageNumber={this._updatePageNumber}
                  windowWidth={this.state.width}
                />
              )}
          </div>
        </div>
        <MainMenu
          isbn={this.props.isbn}
          powerByPositionSt={this.state.powerByPositionSt}
          updatePowerByClass={this._updatePowerByClass}
          environment="reader"
        />
        <Tooltip tooltip={this.state.tooltip} />
        {!Fraction.User && <LoadingContainer />}
      </div>
    );
  }

  _saveChromeState(id, state) {
    this.savedChromeStates[id] = state;
    this.forceUpdate();
  }

  _loadChromeState(id) {
    return this.savedChromeStates[id];
  }

  _skipAhead() {
    if ($("#jigsaw-placeholder").length > 0) {
      $("#jigsaw-placeholder")[0].focus();
    }
  }

  _hideEresourceModal(hideMessage) {
    const eresources = Fraction.Helpers.getUserData("eresources") || {};
    eresources[this.props.isbn] = { hideMessage };
    Fraction.Helpers.saveUserData("eresources", eresources);
    toastUtils.dismiss("eresources-access-code-toast");
  }

  _revealAccessCode() {
    const book = BookStore.get(this.props.isbn);
    Fraction.Helpers.showModal({
      title: `${i18n.t("eresources.courseware")}: ${book.title.decodeHTML()}`,
      content: <AccessCodeModal isbn={this.props.isbn} />,
      closeCallback: function () {},
      className: "courseware-modal",
      definingClass: "courseware-modal",
      buttons: [],
      width: 500
    });
    toastUtils.dismiss("eresources-access-code-toast");
  }

  _renderRevealButton() {
    return (
      <span>
        {i18n.t("eresources.modal-message")}
        <button
          className="noButton"
          style={{ marginLeft: "5px", fontSize: "14px" }}
          onClick={this._revealAccessCode}
        >
          {window.toHTML(i18n.t("eresources.click-here-to-reveal"))}
        </button>
      </span>
    );
  }

  _showEresourceModal() {
    const eresources = Fraction.Helpers.getUserData("eresources");
    const eresource = (eresources && eresources[this.props.isbn]) || {};
    const book = BookStore.get(this.props.isbn);
    if (
      !book.ssoOnly &&
      !eresource.hideMessage &&
      this.state.ancillaries.some(
        a => a.isbn === this.props.isbn && a.accessCodeCount
      )
    ) {
      toastUtils.notify({
        id: "eresources-access-code-toast",
        children: this._renderRevealButton(),
        imageUrl: book.coverURL && book.coverURL.replace(":width", "60"),
        backgroundColor: "#ECECEC",
        borderColor: "darkorange",
        borderPosition: "left",
        checkboxText: i18n.t("base.dont-show-again"),
        horizontalPosition: "right",
        maxWidth: 200,
        dismissible: true,
        onCheckboxChange: this._hideEresourceModal
      });
    }
  }

  renderMinimizedChrome(chrome, text) {
    const chromeState = this.savedChromeStates[chrome];
    if (chromeState && chromeState.status === "minimized") {
      return (
        <div id="assignment-minimized" className="noSelect">
          <button
            className="open noButton"
            onClick={() => {
              this.savedChromeStates[chrome].status = "opened";
              Dispatcher.emit(Dispatcher.HIDE_ALL_PANELS);
              Dispatcher.emit(Dispatcher.CHANGE_CHROME, chrome, {
                assignmentId: this.props.assignmentId
              });
            }}
          >
            {i18n.t("assignments.back-assignments")}
          </button>
          <button
            className="close noButton"
            onClick={() => this._saveChromeState(chrome, false)}
          >
            <Isvg src="/img/x_white.svg" />
            <span className="offScreen">
              {i18n.t("assignments.cancel-assignment")}
            </span>
          </button>
        </div>
      );
    }
  }

  _buildChrome(BookJSX, Objects) {
    let chrome = <span />;

    if (this.state.chrome) {
      const gadgetId = this.state.chrome.metadata().id;
      chrome = (
        <this.state.chrome.class
          isbn={this.props.isbn}
          {...this.state.chromeProps}
          saveState={state => {
            this._saveChromeState(gadgetId, state);
          }}
          savedState={this._loadChromeState(gadgetId)}
        >
          {Objects}
          {BookJSX}
        </this.state.chrome.class>
      );
    } else {
      chrome = this._getBookTemplate(BookJSX, Objects);
    }
    return chrome;
  }

  render() {
    const book = BookStore.get(this.props.isbn);
    var bookHorizontalBounds = { left: 0, right: 0 };
    if (!Fraction.Helpers.isSmallScreen()) {
      bookHorizontalBounds = {
        left: this.state.activePanel ? 320 : 0
      };
    }

    const BookJSX = (
      <BookContainer
        isbn={this.props.isbn}
        toggleMobileMenuEvent={this._toggleMobileMenu}
        hideScrubberEvent={this._hideScrubberContainer}
        cancelScrubberShowEvent={this._cancelShowingScrubber}
        fastHighlighting={this.state.fastHighlighting}
        scrubber_expanded={this.state.scrubber_expanded}
        redraw={this._redraw}
        bookHorizontalBounds={bookHorizontalBounds}
      />
    );

    const Objects = (
      <span id="reader-overlays">
        <Tour ref={this.tourRef} />
        {Fraction.Helpers.modalToShow}
        <ModalManager />
      </span>
    );

    const chrome = this._buildChrome(BookJSX, Objects);

    const modalOpen = FractionStore.get()["modal-open"];

    return (
      <div id="reader-handler" key={`reader-lang-${i18n.getCurrentLocale()}`}>
        <button
          onClick={this._skipAhead}
          aria-hidden={modalOpen}
          tabIndex={modalOpen ? -1 : 0}
          className="noButton hidden-accessibility"
        >
          <span>{i18n.t("reader.skip-ahead")}</span>
        </button>
        <div id="chrome-handler">{chrome}</div>
        <JigsawPlaceholder
          isbn={this.props.isbn}
          toggleMobileMenuEvent={this._toggleMobileMenu}
          hideScrubberEvent={this._hideScrubberContainer}
          cancelScrubberShowEvent={this._cancelShowingScrubber}
          fastHighlighting={this.state.fastHighlighting}
          scrubber_expanded={this.state.scrubber_expanded}
          assignmentId={this.props.assignmentId}
          redraw={this._redraw}
          bookHorizontalBounds={bookHorizontalBounds}
          renderMinimizedChrome={this.renderMinimizedChrome}
          bookAccessDenied={book.bookAccessDenied}
        />
      </div>
    );
  }
}
module.exports = Container;
